import script from "./SecurityUserTab.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"
export * from "./SecurityUserTab.vue?vue&type=script&setup=true&name=BasicInfoTab&lang=js"

import "./SecurityUserTab.vue?vue&type=style&index=0&id=2efd5eba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2efd5eba"]])

export default __exports__